import React, {useContext} from "react";
import {directusContext} from "../../app/DirectusProvider";
import EnfantCoursList from "./enfantCours/EnfantCoursList";
import CoursList from "./CoursList";
import Roles from "../../app/config/Roles";

const Cours = props => {
    const {currentUser} = useContext(directusContext);
    const historique = props.historique ?? false;

    switch (currentUser.role.name) {
        case Roles.administrateur:
        case Roles.coach:
        case Roles.moniteur:
            return (
                <CoursList historique={historique}/>
            );
        case null:
            return null;
        default:
            return (
                <EnfantCoursList historique={historique}/>
            );
    }
};

export default Cours;